import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-discharge-report-section',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './discharge-report-section.component.html',
  styleUrls: ['./discharge-report-section.component.css'],
})
export class DischargeReportSectionComponent {
  @Input({ required: true }) title!: string;
}